import i18n from '@/i18n';
import { checkIsPublicRoute } from '@nxtpeople/nxt-vue-keycloak';
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { checkAccess } from '../helpers/auth.helper';
import { Scope, ScopeType } from '../models/allowed-scopes.interface';
import { publicRoutes } from '../router';
import store from '../store';

const AUTH_GUARD = async (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
   if (checkIsPublicRoute(to, publicRoutes))
      /* Checking if the user is trying to access the error page and if the error page has the correct query params. */
      checkErrorPage(to, next);

   /* Fetching the user information from the backend. */
   await fetchUserInfo();

   /* Checking if the user has the permission to access the route. */
   checkIfUserHasPermission(to, next);
};

function checkErrorPage(to: RouteLocationNormalized, next: NavigationGuardNext) {
   const isErrorPage = to.name === 'ErrorPage';
   const hasErrorParams = to.query.error_code && to.query.error_title;

   if (isErrorPage) {
      if (!hasErrorParams) return next('/');
      //user will not be fetched so loading can be disabled
      store.state.userInfo!.loadingUserInfo = false;
      return next();
   }
}

function checkIfUserHasPermission(to: RouteLocationNormalized, next: NavigationGuardNext) {
   const requiresPermission = !!to.meta.permission;
   if (!requiresPermission) return next();

   const hasRequiredPermission = checkAccess(to.meta.permissions as ScopeType, Scope.View);
   if (hasRequiredPermission) return next();

   return next({
      path: '/error',
      query: {
         error_code: '403',
         error_title: i18n.global.t('generic.access-denied'),
         error_message: i18n.global.t('generic.u-have-no-access'),
         error_navigate_text: i18n.global.t('generic.back-to-home-screen'),
         error_navigate_path: window.location.origin,
      },
   });
}

async function fetchUserInfo() {
   if (!store.state.userInfo?.userInfo) {
      await store.dispatch('userInfo/getUserInfo', { embed: 'scopes,teams', include: 'roles' });
   }
}

export default AUTH_GUARD;
